import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
  TextFilter,
  SafePipe,
  SafeHTML,
  FileSize,
  SafeStyles,
  Truncate,
  StripHtmlPipe,
  SanitizeHtmlTooltipPipe,
  FriendlyType,
  TransformTextPipe,
  TranslationPipe,
  TranslationDatePipe,
  TranslationFromStringPipe,
  FormatText,
  LocalizeDatePipe,
  PipeFromText,
  HighlightPipe,
} from '@app/shared/pipe.module';
import { EditorModule as TinyMCEModule } from '@scaffold/tinymce/editor/editor.module';
import { MentionModule } from '@app/commenting/mentions/mention.module';
import { FileDropDirective } from './file-drop.directive';
import { NgJsonEditorModule } from 'ang-jsoneditor';
import { ShowFalsyPipe } from './pipe.module';
import { TourTargetDirective } from '@services/tour-target.directive';
import { TextOverflowDirective } from './text-overflow.directive';
import { AngularSplitModule } from 'angular-split';
import { PrimengModule } from './primeng.module';

@NgModule({
  imports: [
    CommonModule,
    MentionModule,
    FormsModule,
    AngularSplitModule,
    TinyMCEModule,
  ],
  exports: [
    TextOverflowDirective,
    HighlightPipe,
    ShowFalsyPipe,
    SafePipe,
    SafeHTML,
    TextFilter,
    SafeStyles,
    FileSize,
    FormatText,
    LocalizeDatePipe,
    FriendlyType,
    PipeFromText,
    Truncate,
    StripHtmlPipe,
    SanitizeHtmlTooltipPipe,
    TinyMCEModule,
    MentionModule,
    PrimengModule,
    NgJsonEditorModule,
    TransformTextPipe,
    TranslationPipe,
    TranslationDatePipe,
    TranslationFromStringPipe,
    TourTargetDirective,
  ],
  declarations: [
    TextOverflowDirective,
    HighlightPipe,
    ShowFalsyPipe,
    SafePipe,
    SafeHTML,
    TextFilter,
    FileSize,
    FormatText,
    LocalizeDatePipe,
    FriendlyType,
    SafeStyles,
    Truncate,
    StripHtmlPipe,
    SanitizeHtmlTooltipPipe,
    FileDropDirective,
    TransformTextPipe,
    TranslationPipe,
    TranslationDatePipe,
    TranslationFromStringPipe,
    PipeFromText,
    TourTargetDirective,
  ],
  providers: [LocalizeDatePipe, PipeFromText],
})
export class SharedModule {}
